import { Fetcher } from '@this/src/util';
import type { ShareholderTicketFeesAirportOption } from './shareholder_ticket_fees_airport_select';

interface AirportResponse {
  name: string;
  airport_code: string;
}

const SEARCH_PATH = '/arrangement/shareholder_ticket_fee_airports/search.json';

export const fetchShareholderTicketFeeAirportsByName = async (
  name: string
): Promise<ShareholderTicketFeesAirportOption[]> => {
  const result = await Fetcher.get<AirportResponse[]>(SEARCH_PATH, { name });
  return result.map(airport => ({
    label: airport.name,
    code: airport.airport_code
  }));
};
